<template>
  <div class="selectView">
    <el-select style="width: 100%;" v-model="localValue" clearable :placeholder="`请选择${txt}`" @change="changeSelect">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'selectView',
  props: {
    txt: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
    }
  },
  data() {
    return {
      localValue: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    // 监听 localValue 的变化，并通知父组件
    localValue(newVal) {
      this.$emit('changeSelect', newVal);
    }
  },
  methods: {
    changeSelect(val) {
      this.$emit('changeSelect', val)
    }
  }
}
</script>
<style lang="scss" scoped></style>
